import { FooterAccountsPage } from "./FooterAccountsPage";
export default FooterAccountsPage;



// WEBPACK FOOTER //
// ./src/components/atomic/organisms/FooterAccountsPage/index.js